<div class="app-container">
	<div class="app-view">
		<router-outlet />
		<lgb-scan-card></lgb-scan-card>
		<lgb-notification></lgb-notification>
	</div>
	<div [class.app]="!menu.isNone()">
		<lgb-menu></lgb-menu>
	</div>
</div>